<template>
  <section class="retailer-confirmation" v-if="showComponent">
    <div class="retailer-confirmation__header">
      <img class="retailer-confirmation__icon" src="~@/assets/images/icon/car-appointment.svg" />
      <h2 class="retailer-confirmation__heading">{{title}}</h2>
    </div>
    <div class="retailer-confirmation__body" :class="{ 'retailer-confirmation__body--slim' : showAdditionalText }">
      <template v-if="appointment">
        <h3 class="retailer-confirmation__text retailer-confirmation__text--lg">{{appointment.dateFormatted}}</h3>
        <span class="retailer-confirmation__text">{{appointment.startEndTimeFormatted}}</span>
      </template>

      <div class="retailer-confirmation__image">
        <img :src="imageUrl" :alt="`${currentRange.manufacturerName} ${currentRange.rangeName}`" />
      </div>

      <div class="retailer-confirmation__model-details">
        <span class="retailer-confirmation__text">Your model</span>
        <h3 class="retailer-confirmation__text retailer-confirmation__text--lg">{{currentRange.manufacturerName}} {{currentRange.rangeName}}</h3>
        <span class="retailer-confirmation__text" v-if="currentBodyStyle">{{currentBodyStyle.modelName}} †</span>
      </div>

      <div>
        <span class="retailer-confirmation__text">
          <span class="retailer-confirmation__text--uppercase">{{retailer.retailerName}}</span>
        </span>
        <span class="retailer-confirmation__text">{{retailer.address.addressLine1}} {{retailer.address.postCode}}</span>
        <span class="retailer-confirmation__text">{{retailer.distanceInMiles}} Miles away</span>
      </div>

      <div v-if="showAdditionalText" class="retailer-confirmation__additional-text">
        <span class="retailer-confirmation__text retailer-confirmation__text--sm" v-html="formattedAdditionalText" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import SelectedTimeSlot from '@/models/date-picker/SelectedTimeSlot';
import SearchQuery from '@/models/SearchQuery';
import IRetailerVehicleAvailability from '@/models/test-drive/interfaces/retailer-vehicle-availability.d';
import IDerivative from '@/models/vehicle/interfaces/derivative.d';
import IRange from '@/models/vehicle/interfaces/range.d';
import { imageUrlService } from '@/services/ImageUrlService';
import { tokenService } from '@/services/TokenService';
import {
  Vue, Component, Prop
} from 'vue-property-decorator';
import {
  namespace
} from 'vuex-class';

const VehicleModule = namespace('vehicleModule');
const SearchQueryModule = namespace('searchQueryModule');

@Component
export default class RetailerConfirmationComponent extends Vue {
  @VehicleModule.Getter public currentRange!: IRange;

  @VehicleModule.Getter public currentBodyStyle!: IDerivative | null;

  @SearchQueryModule.Getter public searchQuery!: SearchQuery;

  @Prop({ default: 'Your Chosen Dealership' })
  public title!: string;

  @Prop({ default: false })
  public showAdditionalText!: boolean;

  @Prop({ default: 'We\'ll send an email to confirm your request.<br />We will be in touch with further details.' })
  public additionalText!: string;

  @Prop({ default: false })
  public showIfHasAppointment!: boolean;

  public get appointment(): SelectedTimeSlot | null {
    return this.$store.getters['testDriveAvailabilityModule/appointment'];
  }

  public get showComponent(): boolean {
    if (this.appointment && !this.showIfHasAppointment) {
      return false;
    }

    if (!this.appointment && this.showIfHasAppointment) {
      return false;
    }

    if (this.currentRange && this.retailer) {
      return true;
    }

    return false;
  }

  public get retailer(): IRetailerVehicleAvailability | null {
    return this.$store.getters['retailerModule/selectedRetailer'];
  }

  public isFallback: boolean = false;

  public get formattedAdditionalText() {
    return tokenService.replaceToken(this.additionalText);
  }

  public get vehicleType(): string {
    return this.searchQuery.vehicleType === 1 ? 'car' : 'van';
  }

  public get imageUrl() : string {
    return imageUrlService.imageUrl();
  }

  public get manufacturerLogo(): string {
    if (this.currentRange !== null) {
      return `//image.uk-tla.com/api/v1/image/vehicle/${this.vehicleType}/${this.currentRange.manufacturerNameSlug}/logo/200`;
    }

    return '';
  }
}
</script>
